// import
import * as THREE from 'three'
import type { GLTF } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { loadGLTFModel, modelTransform } from '../utils'
import { TransformOptions } from '../types'
import type { AnimatorOptions } from './BaseAnimator'

export interface BaseModelOptions {
  transform?: TransformOptions
  renderOrder?: number
  animations: string[]
  animatorOptions?: AnimatorOptions
}

export abstract class BaseModel {

  public object: THREE.Group = new THREE.Group()
  protected gltf?: GLTF
  protected config?: BaseModelOptions | any

  constructor(config?: BaseModelOptions|any) { //, camera?: THREE.Camera){
    this.config = config
  }

  async load(scene: THREE.Scene): Promise<void> {

    const url = this.getModelUrl()
    if (!url) throw new Error(`${this.constructor.name}: model url not found`)

    return new Promise((resolve) => {

      loadGLTFModel(url, {
        onLoad: (gltf: GLTF) => {

          this.gltf = gltf
          this.object.add(gltf.scene)

          if (this.config?.transform) {
            modelTransform(this.object, this.config.transform)
          }

          this.onLoaded(gltf)
      
          if (this.config?.renderOrder) {
            this.object.renderOrder = this.config.renderOrder
          }

          scene.add(this.object)
          resolve()
        },
      })

    })
  }

  protected abstract getModelUrl(): string

  protected abstract onLoaded(gltf: GLTF): void

  update(_delta: number): void {}
}
